/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateDocumentMutationRequest,
  UpdateDocumentMutationResponse,
  UpdateDocumentPathParams,
  UpdateDocument400,
  UpdateDocument404,
} from '../types/UpdateDocument'

function getUpdateDocumentUrl({ id }: { id: UpdateDocumentPathParams['id'] }) {
  const res = { method: 'PATCH', url: `/api/v1/documents/${id}/` as const }
  return res
}

/**
 * @description ViewSet for document operations.
 * Uses hybrid architecture:
 * - READ operations (list, quota): Uses DRF ModelViewSet with filtering/sorting ecosystem
 * - WRITE operations (create, update, replace, delete, bulk-assign-brand): Uses Use Case pattern
 * M1.4: Implements list, create, update, delete, and storage quota.
 * M1.5 (FIR-4393): Added replace endpoint for versioning with soft delete.
 * @summary Update document metadata
 * {@link /api/v1/documents/:id/}
 */
export async function updateDocument(
  { id }: { id: UpdateDocumentPathParams['id'] },
  data?: UpdateDocumentMutationRequest,
  config: Partial<RequestConfig<UpdateDocumentMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateDocumentMutationResponse,
    ResponseErrorConfig<UpdateDocument400 | UpdateDocument404>,
    UpdateDocumentMutationRequest
  >({
    method: 'PATCH',
    url: getUpdateDocumentUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
